import React from 'react';
import { stats } from '../../data/content';
export function StatsStrip() {
  return <section aria-label="Master Welding System in numbers" className="w-full border-y border-white/10 bg-ink-900 px-4 py-7 sm:px-6" data-id="element-233" data-mp="289qt5vwd2xx7">
      <ul className="mx-auto grid w-full max-w-5xl grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-4" data-id="element-234" data-mp="2m8qasjlgicjv">
        {stats.map(stat => <li key={stat.label} className="text-center" data-id="element-235" data-mp="2i5tsktztwigg">
            <p className="font-display text-3xl font-bold leading-none text-teal-bright sm:text-4xl" data-id="element-236" data-mp="1uivjwihyaet3">
              {stat.value}
            </p>
            <p className="mt-1.5 text-[11px] font-semibold uppercase leading-tight tracking-wider text-white/55 sm:text-xs" data-id="element-237" data-mp="23adw6ibs0agw">
              {stat.label}
            </p>
          </li>)}
      </ul>
    </section>;
}